<template>
<div class="chapter">
<div class="inner_page">
<section class="minitoc notoc" data-pdf-bookmark="Mini TOC" data-type="preface" epub:type="preface"><div class="preface" id="d13e18"><h1 class="ChapTitleNonprintingctnp" data-displayheader="no">Mini TOC</h1><p style="text-align: center; text-indent: 0; line-height: 1.5em;"><a class="spanhyperlink" href="#/ch01#d1e431" id="beginreading">Begin Reading</a></p><p style="text-align: center; text-indent: 0; line-height: 1.5em;"><span class="spanhyperlink" href="#/toc01#z_TOC" id="toc" title="Link target outside of Sample">Table of Contents</span></p><p style="text-align: center; text-indent: 0; line-height: 1.5em;"><span class="spanhyperlink" href="#/app01#d1e12310" id="abouttheauthor" title="Link target outside of Sample">About the Author</span></p><p style="text-align: center; text-indent: 0; line-height: 1.5em;"><a class="spanhyperlink" href="#/copyrightpage01#d1e282" id="copyright-page">Copyright Page</a></p></div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface01.vue?4c3ce346